import { transportOrderFragment } from 'apollo/fragments';
import { gql } from 'graphql.macro';

export const createTransportAsAdminTemplate = gql`
    mutation createTransportAsAdmin(
        $clinic: ID!
        $serviceCode: TransportServices!
        $transportDay: String!
        $manualPackageCount: Int!
        $lab: ID
        $comment: String
        $deadline: String
        $internalMessage: String
        $isAlreadyCollected: Boolean
    ) {
        createTransportAsAdmin(
            clinic: $clinic
            serviceCode: $serviceCode
            transportDay: $transportDay
            manualPackageCount: $manualPackageCount
            lab: $lab
            comment: $comment
            deadline: $deadline
            internalMessage: $internalMessage
            isAlreadyCollected: $isAlreadyCollected
        ) {
            _id
        }
    }
`;

export const updateTransportTemplate = gql`
    mutation updateTransport(
        $transportOrderId: MongoDbObjectId!
        $manualPackageCount: Int
        $comment: String
        $internalMessage: String
        $deadline: String
    ) {
        updateTransport(
            transportOrderId: $transportOrderId
            manualPackageCount: $manualPackageCount
            comment: $comment
            internalMessage: $internalMessage
            deadline: $deadline
        ) {
            ...transportOrderFields
        }
    }
    ${transportOrderFragment}
`;

export const updateTransportHasProblemTemplate = gql`
    mutation updateTransportHasProblem($_id: MongoDbObjectId!) {
        updateTransportHasProblem(_id: $_id)
    }
`;
